module.exports = __webpack_public_path__ + "graphics/player-fullscreen.ckh.fd16c42a328f0a5be9fb92b6f9f5c4b3.svg";